import * as React from "react";
import { connect } from "react-redux";
import { IdStyles } from "../../../less/IdStyles";
import { selectCoopProjectInfo } from "../../../selectors/selectCoopProjectInfo";
import { IdLoca } from "../../../utils/i18n/IdLoca";
import { DialogWrapper } from "../../dialog/DialogWrapper";
import { ButtonConfirmation } from "../../generic/common/ButtonConfirmation";
import { TextLoca } from "../../generic/text/TextLoca";
import { actionModalClose } from "../../modals/actionModal";
import { IdModal } from "../../modals/IdModal";
import { actionCoopProjectStop } from "../actionCoop";
var _DialogCoopProjectStopConfirmation = function (_a) {
    var activeCoopProject = _a.activeCoopProject, onConfirmation = _a.onConfirmation, onCancel = _a.onCancel;
    var onClickConfirm = function () {
        if (activeCoopProject && activeCoopProject.projectId) {
            onConfirmation(activeCoopProject.projectId);
        }
    };
    return (React.createElement(DialogWrapper, { titleLocaId: IdLoca.cancelProjectConfirmation_title, onClose: onCancel, className: IdStyles.ModalBackgroundResources },
        React.createElement("div", { className: "dialog-coop__confirmation" },
            React.createElement(TextLoca, { className: IdStyles.TextNormal, id: IdLoca.cancelProjectConfirmation_desc }),
            React.createElement(ButtonConfirmation, { onClickCancel: onCancel, onClickConfirm: onClickConfirm }))));
};
var mapState = function (state) { return ({
    activeCoopProject: selectCoopProjectInfo(state),
}); };
var mapDispatch = function (dispatch) { return ({
    onCancel: function () { return dispatch(actionModalClose(IdModal.CoopProjectStopConfirm)); },
    onConfirmation: function (projectTypeId) {
        dispatch(actionCoopProjectStop(projectTypeId));
        dispatch(actionModalClose(IdModal.CoopProjectStopConfirm));
    },
}); };
export var DialogCoopProjectStopConfirmation = connect(mapState, mapDispatch)(_DialogCoopProjectStopConfirmation);



//////////////////
// WEBPACK FOOTER
// ./src/features/cooperative/projects/DialogCoopProjectStopConfirmation.tsx
// module id = 2812
// module chunks = 3